import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { green, grey, red } from "@mui/material/colors";
 
const CustomCheckBox = ({
  checked,
  onChange,
  disabled,
  disableColor,
  size,
  className
}) => {
 
  return (
    <Checkbox
      onChange={onChange}
      checked={checked}
      disabled={disabled}
      size={size ? size : "medium"}
      className={className}
      is
      sx={
        disabled
          ? {
            color: grey[700],
            "&.Mui-checked": {
              color: green[900],
            },
            "&.Mui-disabled": {
              color: disableColor ? disableColor : red[600],
            },
          }
          : {
            color: grey[700],
            "&.Mui-checked": {
              color: green[700],
            },
          }
      }
    />
  );
};
 
export default CustomCheckBox;